export const PageSize = 10;

export const INCSCREEN_MAIN_INSTRUCTION_TEXT = `* Your screening consists of {{number}} questions.
* Answer the call in a quiet environment to ensure your responses are captured clearly.
* The screening call will be recorded and analyzed for recruitment, quality, monitoring, and evaluation purposes.
* If you do not answer the call, the call gets disconnected, or there is a network interruption, you may be able to reattempt the screening within the allowed time.
* Any attempt to manipulate or misuse the screening process may result in disqualification.
* Please ensure your phone is reachable, has sufficient battery, and you are in an area with good network coverage.`;

export const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
export const fileExtension = ".xlsx";
export const ASSET_NAMES = {
  ADD_CANDIDATE_BLUE: "add-candidate-blue.svg",
  ADD_CANDIDATE_GREY: "add-candidate-grey.svg",
  CANCEL_BTN_BLUE: "cancel-btn-blue.svg",
  MANUAL_INVITE_BLUE: "manual-invite-blue.svg",
  COPY_LINK_BTN_GREY: "copy-link-btn-grey.svg",
  GREY_SAVE_ICON: "grey-save-icon.svg",
  BLUE_SAVE_ICON: "blue-save-icon.svg",
  INFO_ICON_CYAN: "info-icon-cyan.svg",
  UNDO_ICON_BLUE: "undo-icon-blue.svg",
  DELETE_ICON_RED: "delete-icon-red.svg",
  WARNING: "warning.svg",
  EDIT_ICON: "edit_icon.svg",
};
export const PRODUCT_STATUSES = {
  SUBSCRIBED: "Subscribed",
  UNSUBSCRIBED: "Unsubscribed",
};
export const CandidateQuestionsNew = [
  {
    question:
      "What work setup are you comfortable with — remote, hybrid or work-from-office?",
    questionType: "global",
    answer:
      "The candidate should clearly indicate that they are comfortable with <WORK_SETUP> and specify any constraints or confirm that there are none.",
  },
  {
    question:
      "What is your current notice period, and from when would you be available to join if selected?",
    questionType: "global",
    answer:
      "The candidate should mention a notice period of <NOTICE_PERIOD> and confirm availability to join accordingly.",
  },
  {
    question: "What are your current salary expectations for this role?",
    questionType: "global",
    answer:
      "The candidate should state a salary expectation within the range of <SALARY_RANGE>.",
  },
  {
    question:
      "Are there any deal breakers for you — for example strict in-office requirement, relocation, or other non-negotiable factors?",
    questionType: "global",
    answer:
      "The candidate should indicate that they have no deal breakers (e.g., relocation, strict in-office requirement, or other non-negotiable factors).",
  },
];
export const timeSlots = [
  "00:00",
  "00:15",
  "00:30",
  "00:45",
  "01:00",
  "01:15",
  "01:30",
  "01:45",
  "02:00",
  "02:15",
  "02:30",
  "02:45",
  "03:00",
  "03:15",
  "03:30",
  "03:45",
  "04:00",
  "04:15",
  "04:30",
  "04:45",
  "05:00",
  "05:15",
  "05:30",
  "05:45",
  "06:00",
  "06:15",
  "06:30",
  "06:45",
  "07:00",
  "07:15",
  "07:30",
  "07:45",
  "08:00",
  "08:15",
  "08:30",
  "08:45",
  "09:00",
  "09:15",
  "09:30",
  "09:45",
  "10:00",
  "10:15",
  "10:30",
  "10:45",
  "11:00",
  "11:15",
  "11:30",
  "11:45",
  "12:00",
  "12:15",
  "12:30",
  "12:45",
  "13:00",
  "13:15",
  "13:30",
  "13:45",
  "14:00",
  "14:15",
  "14:30",
  "14:45",
  "15:00",
  "15:15",
  "15:30",
  "15:45",
  "16:00",
  "16:15",
  "16:30",
  "16:45",
  "17:00",
  "17:15",
  "17:30",
  "17:45",
  "18:00",
  "18:15",
  "18:30",
  "18:45",
  "19:00",
  "19:15",
  "19:30",
  "19:45",
  "20:00",
  "20:15",
  "20:30",
  "20:45",
  "21:00",
  "21:15",
  "21:30",
  "21:45",
  "22:00",
  "22:15",
  "22:30",
  "22:45",
  "23:00",
  "23:15",
  "23:30",
  "23:45",
];

export const displayTimeSlots = {
  "00:00": "12:00 AM",
  "00:15": "12:15 AM",
  "00:30": "12:30 AM",
  "00:45": "12:45 AM",
  "01:00": "01:00 AM",
  "01:15": "01:15 AM",
  "01:30": "01:30 AM",
  "01:45": "01:45 AM",
  "02:00": "02:00 AM",
  "02:15": "02:15 AM",
  "02:30": "02:30 AM",
  "02:45": "02:45 AM",
  "03:00": "03:00 AM",
  "03:15": "03:15 AM",
  "03:30": "03:30 AM",
  "03:45": "03:45 AM",
  "04:00": "04:00 AM",
  "04:15": "04:15 AM",
  "04:30": "04:30 AM",
  "04:45": "04:45 AM",
  "05:00": "05:00 AM",
  "05:15": "05:15 AM",
  "05:30": "05:30 AM",
  "05:45": "05:45 AM",
  "06:00": "06:00 AM",
  "06:15": "06:15 AM",
  "06:30": "06:30 AM",
  "06:45": "06:45 AM",
  "07:00": "07:00 AM",
  "07:15": "07:15 AM",
  "07:30": "07:30 AM",
  "07:45": "07:45 AM",
  "08:00": "08:00 AM",
  "08:15": "08:15 AM",
  "08:30": "08:30 AM",
  "08:45": "08:45 AM",
  "09:00": "09:00 AM",
  "09:15": "09:15 AM",
  "09:30": "09:30 AM",
  "09:45": "09:45 AM",
  "10:00": "10:00 AM",
  "10:15": "10:15 AM",
  "10:30": "10:30 AM",
  "10:45": "10:45 AM",
  "11:00": "11:00 AM",
  "11:15": "11:15 AM",
  "11:30": "11:30 AM",
  "11:45": "11:45 AM",
  "12:00": "12:00 PM",
  "12:15": "12:15 PM",
  "12:30": "12:30 PM",
  "12:45": "12:45 PM",
  "13:00": "01:00 PM",
  "13:15": "01:15 PM",
  "13:30": "01:30 PM",
  "13:45": "01:45 PM",
  "14:00": "02:00 PM",
  "14:15": "02:15 PM",
  "14:30": "02:30 PM",
  "14:45": "02:45 PM",
  "15:00": "03:00 PM",
  "15:15": "03:15 PM",
  "15:30": "03:30 PM",
  "15:45": "03:45 PM",
  "16:00": "04:00 PM",
  "16:15": "04:15 PM",
  "16:30": "04:30 PM",
  "16:45": "04:45 PM",
  "17:00": "05:00 PM",
  "17:15": "05:15 PM",
  "17:30": "05:30 PM",
  "17:45": "05:45 PM",
  "18:00": "06:00 PM",
  "18:15": "06:15 PM",
  "18:30": "06:30 PM",
  "18:45": "06:45 PM",
  "19:00": "07:00 PM",
  "19:15": "07:15 PM",
  "19:30": "07:30 PM",
  "19:45": "07:45 PM",
  "20:00": "08:00 PM",
  "20:15": "08:15 PM",
  "20:30": "08:30 PM",
  "20:45": "08:45 PM",
  "21:00": "09:00 PM",
  "21:15": "09:15 PM",
  "21:30": "09:30 PM",
  "21:45": "09:45 PM",
  "22:00": "10:00 PM",
  "22:15": "10:15 PM",
  "22:30": "10:30 PM",
  "22:45": "10:45 PM",
  "23:00": "11:00 PM",
  "23:15": "11:15 PM",
  "23:30": "11:30 PM",
  "23:45": "11:45 PM",
};

export const customTimeSlots = [
  { value: "", label: "Select Time Slots" },
  { value: "00:00", label: "12:00 AM" },
  { value: "00:15", label: "12:15 AM" },
  { value: "00:30", label: "12:30 AM" },
  { value: "00:45", label: "12:45 AM" },

  { value: "01:00", label: "01:00 AM" },
  { value: "01:15", label: "01:15 AM" },
  { value: "01:30", label: "01:30 AM" },
  { value: "01:45", label: "01:45 AM" },

  { value: "02:00", label: "02:00 AM" },
  { value: "02:15", label: "02:15 AM" },
  { value: "02:30", label: "02:30 AM" },
  { value: "02:45", label: "02:45 AM" },

  { value: "03:00", label: "03:00 AM" },
  { value: "03:15", label: "03:15 AM" },
  { value: "03:30", label: "03:30 AM" },
  { value: "03:45", label: "03:45 AM" },

  { value: "04:00", label: "04:00 AM" },
  { value: "04:15", label: "04:15 AM" },
  { value: "04:30", label: "04:30 AM" },
  { value: "04:45", label: "04:45 AM" },

  { value: "05:00", label: "05:00 AM" },
  { value: "05:15", label: "05:15 AM" },
  { value: "05:30", label: "05:30 AM" },
  { value: "05:45", label: "05:45 AM" },

  { value: "06:00", label: "06:00 AM" },
  { value: "06:15", label: "06:15 AM" },
  { value: "06:30", label: "06:30 AM" },
  { value: "06:45", label: "06:45 AM" },

  { value: "07:00", label: "07:00 AM" },
  { value: "07:15", label: "07:15 AM" },
  { value: "07:30", label: "07:30 AM" },
  { value: "07:45", label: "07:45 AM" },

  { value: "08:00", label: "08:00 AM" },
  { value: "08:15", label: "08:15 AM" },
  { value: "08:30", label: "08:30 AM" },
  { value: "08:45", label: "08:45 AM" },

  { value: "09:00", label: "09:00 AM" },
  { value: "09:15", label: "09:15 AM" },
  { value: "09:30", label: "09:30 AM" },
  { value: "09:45", label: "09:45 AM" },

  { value: "10:00", label: "10:00 AM" },
  { value: "10:15", label: "10:15 AM" },
  { value: "10:30", label: "10:30 AM" },
  { value: "10:45", label: "10:45 AM" },

  { value: "11:00", label: "11:00 AM" },
  { value: "11:15", label: "11:15 AM" },
  { value: "11:30", label: "11:30 AM" },
  { value: "11:45", label: "11:45 AM" },

  { value: "12:00", label: "12:00 PM" },
  { value: "12:15", label: "12:15 PM" },
  { value: "12:30", label: "12:30 PM" },
  { value: "12:45", label: "12:45 PM" },

  { value: "13:00", label: "01:00 PM" },
  { value: "13:15", label: "01:15 PM" },
  { value: "13:30", label: "01:30 PM" },
  { value: "13:45", label: "01:45 PM" },

  { value: "14:00", label: "02:00 PM" },
  { value: "14:15", label: "02:15 PM" },
  { value: "14:30", label: "02:30 PM" },
  { value: "14:45", label: "02:45 PM" },

  { value: "15:00", label: "03:00 PM" },
  { value: "15:15", label: "03:15 PM" },
  { value: "15:30", label: "03:30 PM" },
  { value: "15:45", label: "03:45 PM" },

  { value: "16:00", label: "04:00 PM" },
  { value: "16:15", label: "04:15 PM" },
  { value: "16:30", label: "04:30 PM" },
  { value: "16:45", label: "04:45 PM" },

  { value: "17:00", label: "05:00 PM" },
  { value: "17:15", label: "05:15 PM" },
  { value: "17:30", label: "05:30 PM" },
  { value: "17:45", label: "05:45 PM" },

  { value: "18:00", label: "06:00 PM" },
  { value: "18:15", label: "06:15 PM" },
  { value: "18:30", label: "06:30 PM" },
  { value: "18:45", label: "06:45 PM" },

  { value: "19:00", label: "07:00 PM" },
  { value: "19:15", label: "07:15 PM" },
  { value: "19:30", label: "07:30 PM" },
  { value: "19:45", label: "07:45 PM" },

  { value: "20:00", label: "08:00 PM" },
  { value: "20:15", label: "08:15 PM" },
  { value: "20:30", label: "08:30 PM" },
  { value: "20:45", label: "08:45 PM" },

  { value: "21:00", label: "09:00 PM" },
  { value: "21:15", label: "09:15 PM" },
  { value: "21:30", label: "09:30 PM" },
  { value: "21:45", label: "09:45 PM" },

  { value: "22:00", label: "10:00 PM" },
  { value: "22:15", label: "10:15 PM" },
  { value: "22:30", label: "10:30 PM" },
  { value: "22:45", label: "10:45 PM" },

  { value: "23:00", label: "11:00 PM" },
  { value: "23:15", label: "11:15 PM" },
  { value: "23:30", label: "11:30 PM" },
  { value: "23:45", label: "11:45 PM" },
];

export const secondsTime = [
  { value: 5, label: "05 secs" },
  { value: 10, label: "10 secs" },
  { value: 15, label: "15 secs" },
  { value: 20, label: "20 secs" },
  { value: 25, label: "25 secs" },
  { value: 30, label: "30 secs" },
];

export const KEY_WORD = {
  GLOBAL: "global",
  INCBOT: "incbot",
  INCSCREEN: "incscreen",
  EXPORT_TO_EXCEL: "exportToExcel",
  CREATE: "create",
  DELETE: "delete",
  VIEW: "view",
  POSITIONS: "positions",
  APPLICANTS: "applicant",
  INTERVIEWS: "interviews",
  CANDIDATE: "candidate",
  COMMON_PERMISSION: "commonPermission",
  SUPPORT: "support",
  ACCOUNTS_AND_BILLING: "accountsAndBilling",
  ROLES_AND_SUBUSERS: "rolesAndSubusers",
  PRODUCT_ID: "productId",
  LOCALHOST: "localhost",
  INCRUITER_DOMAIN: "incruiter.com",
  RESUME_REJECTED: "resume rejected",
  PENDING: "pending",
  CANCELED: "canceled",
  INCFEED: "incfeed",
  INCVID: "incvid",
  INCSERVE: "incserve",
};

export const COOKIES_LIST = [
  "productId",
  "userData",
  "moveToIncVid",
  "moveToIncServe",
  "moveToIncBot",
];
export const TOAST_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
};
export const CUSTOM = "custom";
export const SUCCESS_MSG = {
  FILE_UPLOAD: "File uploaded successfully.",
};
export const EMPTY_FILE_MSG = "The uploaded file is empty";
export const COMMON_PAGE_LIST = [
  "/my-profile",
  "/accounts-billing",
  "/settings",
  "/subuser",
  "/contact-enquiries",
  "/roles",
  "/roles-subuser-list",
  "/product",
  "/plan-pricing",
  "/payment-information",
  "/payment-success",
  "/notification",
];
